// en.js
import elementLocale from 'element-ui/lib/locale/lang/en' // 官方英文包

export default {
  ...elementLocale,
  menu: {
    home: 'Home',
    product: 'Products',
    news: 'News & Resources',
    about: 'About Us',
    contact: 'Contact',
    case: 'Case Studies'
  },
  hero: {
    title:"Inclusive intelligent innovation, abundant and sustainable future",
    subtitle:"Accelerate the realization of net-zero carbon sorting, provide innovative intelligent solutions for various industries"
  }
}